export default __webpack_public_path__ + "static/media/add-img.0beb5e9d.svg";